const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const SLACK_HOOK_REGEX = /^https:\/\/hooks.slack.com\/services\/.*/;

export { EMAIL_REGEX, SLACK_HOOK_REGEX };
